module.exports = __webpack_public_path__ + "img/pickup.d7c8e244.svg";